export default __webpack_public_path__ + "static/media/LogoCut.16efbd26.png";